import React, { useEffect } from "react";

import { captureEvent } from "components/posthog/customEventCapture";
import { Icon } from "components/icon/Icon";

import "./Modal.scss";

type Props = {
  children: React.ReactNode;
  onDismiss: () => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  size?: "xs" | "sm" | "md" | "lg";
  modalTitle: string;
  testId?: string;
};

export default function Modal({
  children,
  onDismiss,
  header = <></>,
  footer = <></>,
  size = "lg",
  modalTitle,
  testId
}: Props) {
  const onClickDismiss = () => {
    onDismiss();
  };

  useEffect(() => {
    captureEvent(`opened modal-${modalTitle}`);
    return () => {
      captureEvent(`closed modal-${modalTitle}`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="modal-container" data-testid={testId}>
      <div className={`modal modal-${size} box`}>
        <div className="modal-header">
          <div>{header}</div>
          <Icon
            name={"times"}
            className="modal-close-btn"
            onClick={onClickDismiss}
          />
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">{footer}</div>
      </div>
    </div>
  );
}
